export interface IResumeStore {
  proficiencies: string[];
}

export const DEFAULT_RESUME_STORE = {
  proficiencies: [],
};
